<template>
    <div v-if="loaded" class="nevs-content">
        <div class="nevs-content-top-buttons">
            <NevsButton class="success" @click="saveClick()"><i class="fa-solid fa-floppy-disk"></i>
                {{ $LANG.Get('buttons.save') }}
            </NevsButton>&nbsp;
        </div>
        <NevsCard class="form">
            <NevsSelect :options="orientationOptions" v-model="client.pdf_orientation"
                        :label="$LANG.Get('fields.pdfOrientation') + ':'"></NevsSelect>
            <NevsNumberField :decimal-places="0" v-model="client.pdf_customer_offset_x" :label="$LANG.Get('fields.pdfOffsetCustomerX')"></NevsNumberField>
            <NevsNumberField :decimal-places="0" v-model="client.pdf_customer_offset_y" :label="$LANG.Get('fields.pdfOffsetCustomerY')"></NevsNumberField>
            <NevsNumberField :decimal-places="0" v-model="client.pos_left_margin" :label="$LANG.Get('fields.posLeftMargin')"></NevsNumberField>
            <NevsNumberField :decimal-places="0" v-model="client.pos_right_margin" :label="$LANG.Get('fields.posRightMargin')"></NevsNumberField>
        </NevsCard>
    </div>
</template>

<script>
import Client from "@/models/Client.js";
import NevsButton from "@/components/nevs/NevsButton.vue";
import NevsCard from "@/components/nevs/NevsCard.vue";
import NevsSelect from "@/components/nevs/NevsSelect.vue";
import NevsNumberField from "@/components/nevs/NevsNumberField.vue";

export default {
    name: "PdfSettings",
    components: {NevsNumberField, NevsSelect, NevsCard, NevsButton},
    data() {
        return {
            loaded: false,
            client: new Client(),
            orientationOptions: [
                {
                    'label': this.$LANG.Get('labels.left'),
                    'value': 'L'
                },
                {
                    'label': this.$LANG.Get('labels.right'),
                    'value': 'R'
                },
            ]
        }
    },
    methods: {
        saveClick() {
            let vm = this;
            this.$API.APICall('put', 'client', this.client, (data, success) => {
                if (success) {
                    vm.$LOCAL_BUS.TriggerEvent('notification', {text: this.$LANG.Get('alerts.recordSaved')});
                    vm.$API.APICall('get', 'session', {}, (data, success) => {
                        if (success) {
                            vm.$store.commit('setUser', data.user);
                        }
                    }, false);
                } else {
                    vm.$HELPERS.HandleServerError(vm, data);
                }
            });
        }
    },
    mounted() {
        if (!this.$store.state.user.permissions.includes('ADMINISTRATOR')) {
            this.$LOCAL_BUS.TriggerEvent('popup', {text: this.$LANG.Get('alerts.unauthorized'), type: 'alert'});
            this.$router.push('/');
        }
        this.$store.commit('selectMenu', 'settings');
        this.$store.commit('selectSubMenu', 'pdfSettings');
        this.$store.commit('setBreadcrumbs', [
            {
                label: this.$LANG.Get('modules.settings'),
                link: null
            },
            {
                label: this.$LANG.Get('modules.pdfSettings'),
                link: null
            }
        ]);

        let vm = this;
        this.$API.APICall('get', 'client', {}, (data, success) => {
            if (success) {
                if (data.client !== null) {
                    vm.client.Fill(data.client);
                } else {
                    vm.$HELPERS.HandleServerError(vm, data);
                }
            } else {
                vm.$HELPERS.HandleServerError(vm, data);
            }
            vm.$nextTick(() => {
                vm.loaded = true;
            });
        });
    }
}
</script>

<style scoped>
.form {
    max-width: 600px;
}
</style>
